<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-card elevation="0">
    <!-- FILTER -->
    <v-text-field
      @input="searching"
      prepend-inner-icon="mdi-magnify"
      label="Kişileri Filtrele"
      class="mx-4"
      hide-details
      clearable
    ></v-text-field>
    <v-list>
      <v-subheader class="mx-4">
        KİŞİLER
        <v-spacer></v-spacer>
        <v-btn
          v-if="value.length"
          text
          depressed
          small
          @click="bulk"
        >
          Tümünü Seç
          <v-icon right>compare_arrows</v-icon>
        </v-btn>
      </v-subheader>

      <v-list-item-group
        class="px-4"
        active-class="primary--text"
      >
        <div v-if="value.length">
          <v-list-item
            v-for="(contact, i) in original"
            :key="i"
            @click="runFilter(contact)"
          >
            <v-list-item-icon>
              <v-icon>account_circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ contact.name }} {{ contact.surname }}
              </v-list-item-title>
              <v-list-item-subtitle v-text="contact.phone"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar>
              <v-icon>compare_arrows</v-icon>
            </v-list-item-avatar>
          </v-list-item>
        </div>
        <v-card-text v-else>
          <v-overlay
            absolute
            :value="loading"
            opacity="0"
            z-index="5"
          >
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-overlay>
          <div class="font-weight-light grey--text text-center">
            <span v-if="!loading">{{noValueText}}</span>
          </div>
        </v-card-text>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: 'SelectiveContactList',
  props: {
    loading: Boolean,
    value: {
      type: Array,
      default: () => [],
    },
    header: {
      type: String,
      default: '',
    },
    pagination: {
      type: Object,
      default: () => {},
    },
    noValueText: {
      type: String,
      default: 'Uygun Veri Yok',
    },
    itemValue: {
      type: String,
      default: 'name',
    },
    filter: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    // item: 1,
    menu: false,
    original: [],
  }),
  watch: {
    value(nv) {
      this.original = nv;
    },
  },
  events: {
    'con:filter-change': 'afterTreeChanged',
  },
  methods: {
    runFilter(obj) {
      this.original = this.original.filter(list => list !== obj);
      this.$emit('con:change', obj);
      this.$emit('con:length', this.original.length);
    },
    afterTreeChanged(e, v) {
      if (this.original.length <= 10) {
        this.original.push(v);
      }
    },
    bulk() {
      this.original.forEach((v) => {
        this.runFilter(v);
      });
      this.$emit('con:select-all', this.original);
    },
    searching(val) {
      this.$emit('searching', val);
      // this.original = this.value.filter(item => item.name.includes(val));
    },
  },
};
</script>
